import Vue from "vue";

export default {
  getAppURLs(slug) {
    return Vue.axios.get(`app/urls/${slug}`);
  },
};
